import React from 'react';
// import './unit.css'
const Unit = ({ setPageName, unitData, setSelectedUnit }) => {
  return (
    <div
      className="unit"
      onClick={() => {
        setPageName('topics');
        setSelectedUnit(unitData);
      }}
    >
      <div className="left">
        <p>
          {unitData.unit_id > 10 ? unitData.unit_id : '0' + unitData.unit_id}
        </p>
        <div className="det">
          <h4>{unitData.unit_name}</h4>
          <p>{unitData.flash_num}Question</p>
        </div>
      </div>
      <div className="right">
        <img
          src={require("../../../../../../Assets/images/inter.png")}
          alt=""
        />
      </div>
    </div>
  );
};

export default Unit;
